import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { withBasePath } from '_config/basePath';
import { prepareAuthHeaders } from './auth';
import cheerio from 'cheerio';
import { method } from 'lodash';


const toFormData = (item) => {
    let form_data = new FormData();

    for (let key in item) {
        form_data.append(key, item[key]);
    }
    return form_data;
}


export const refApi = createApi({
    reducerPath: 'refApi',
    baseQuery: fetchBaseQuery({
        baseUrl: withBasePath(''),
    }),
    endpoints: (builder) => ({
        searchRef: builder.mutation<any, any>({
            queryFn: async (args) => {
                const query = args.query;
                const page = args.page || 1;
                const perPage = 20;

                try {
                    // OpenAlex Search
                    // Using 'search' param for full-text search as recommended
                    const openAlexUrl = `https://api.openalex.org/works?search=${encodeURIComponent(query)}&per-page=${perPage}&page=${page}&mailto=contact@anystyle.io`;
                    const response = await fetch(openAlexUrl);
                    const openAlexRes = await response.json();

                    // Normalize OpenAlex results
                    const items = (openAlexRes.results || []).map(item => ({
                        id: item.id,
                        // Clean DOI to just the ID part if needed, but existing code expects plain DOI string or URL?
                        // FootnoteMenu: "const doi = paper.DOI;" -> getRefInfos({ doi: ref.doi }) -> url: 'https://doi.org/' + args.doi
                        // So if we provide "10.1000/xyz", getRefInfos calls "https://doi.org/10.1000/xyz".
                        // OpenAlex provides "https://doi.org/10.1000/xyz". We should strip prefix.
                        doi: item.doi ? item.doi.replace('https://doi.org/', '') : null,
                        title: item.display_name,
                        // OpenAlex authors are in authorships
                        authors: item.authorships?.map(a => a.author.display_name).join(', ') || '',
                        year: item.publication_year,
                        venue: item.primary_location?.source?.display_name || item.type,
                        type: item.type,
                        source: 'OpenAlex'
                    }));

                    return {
                        data: {
                            totalResults: openAlexRes.meta?.count || 0,
                            items: items
                        }
                    };

                } catch (error: any) {
                    console.error('Search error:', error);
                    return { error: { status: 500, data: error.message } };
                }
            }
        }),
        getRefInfos: builder.mutation<any, any>({
            query: (args) => ({
                url: 'https://doi.org/' + args.doi,
                method: 'GET',
                headers: {
                    "Accept": "application/x-bibtex"
                },
            }),
        }),
        parseRef: builder.mutation<any, any>({
            query: (body) => ({
                url: '/api/references/parse',
                method: 'POST',
                body: JSON.stringify({ references: body })
            }),
        }),
    })
});

export const { useSearchRefMutation, useParseRefMutation, useGetRefInfosMutation, } = refApi;
